import React from "react";
import styled from "styled-components";
import LibraryPage from "./LibraryPage/LibraryPage";

export const StyledHome = styled.div``;

const Home = () => {

  return (
    <StyledHome>
      <LibraryPage />
    </StyledHome>
  );
};

export default Home;
